import React, { useContext } from "react";
// import { useTranslation } from "react-i18next";
import { LangContext } from "../context/lang-context";

function OpeningTimesTable(props) {
  // const { t } = useTranslation();
  const { lang } = useContext(LangContext);

  if(!props.times) return <></>;

  return (
    <div className="tw-p-5 tw-pt-8">
      <table className="tw-w-full tw-table-auto tw-text-left">
        <tbody>
          {Object.values(props.times).map((time, index) => {
            return (
              <tr key={"opening_hours_" + index}>
                <th className="tw-font-bold">
                  {time.text_i18n
                    ? time.text_i18n[lang]
                    : time.text
                    ? time.text[lang]
                    : "—"}
                </th>
                <td className="tw-pl-4 tw-text-right">
                  {time.open}
                  &ndash;
                  {time.close}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default OpeningTimesTable;
